"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const react_1 = __importDefault(require("react"));
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const noCustomers_webp_1 = __importDefault(require("assets/images/dashboard/noCustomers.webp"));
const noSearch_webp_1 = __importDefault(require("assets/images/dashboard/noSearch.webp"));
const customersCopy_1 = require("copy/customersCopy");
const EmptyState = ({ hasFilters, loading }) => {
    let header = '';
    let body = '';
    let image;
    switch (true) {
        case hasFilters:
            header = customersCopy_1.customersCopy.noCustomersFound;
            body = customersCopy_1.customersCopy.noCustomersFoundParagraph;
            image = noSearch_webp_1.default;
            break;
        case loading:
            header = 'Loading...';
            body = '';
            image = noSearch_webp_1.default;
            break;
        default:
            header = customersCopy_1.customersCopy.noCustomersHeader;
            body = customersCopy_1.customersCopy.noCustomersParagraph;
            image = noCustomers_webp_1.default;
            break;
    }
    return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
        react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: 'no records', src: image }),
        react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header no-records', role: 'heading' }, header),
        react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-records-paragraph', role: 'paragraph' }, body)));
};
exports.EmptyState = EmptyState;
